// ! LOCATION FINDER
export const addressFinder = async function (addressInput) {
  document.addEventListener('DOMContentLoaded', (e) => {
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const lat = position.coords.latitude;
        const lon = position.coords.longitude;
        const url = `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${lat}&longitude=${lon}&localityLanguage=en`;

        const res = await fetch(url);
        const data = await res.json();
        const locality = data.localityInfo.administrative
          .map((el) => el.name)
          .reverse()
          .join(' ');
        // * DISPLAY LOCATION
        const deliver = document.querySelectorAll('.loc-text h3');
        deliver.forEach((el) => (el.innerText = data.city));
        addressInput.textContent = locality + data?.postcode;
      },
      (error) => console.log(error),
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      }
    );
  });
};
